import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlarmFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 1489",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Subtract",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.9857 0.865697C3.61001 0.241382 4.62991 0.241382 5.25422 0.865697L6.76877 2.38024C6.39534 2.56391 6.03557 2.77112 5.69142 2.99995L4.4057 1.71423C4.25001 1.55854 3.98991 1.55854 3.83423 1.71423L1.71423 3.83423C1.55854 3.98991 1.55854 4.25001 1.71423 4.4057L2.99997 5.69145C2.77115 6.0356 2.56394 6.39537 2.38029 6.76881L0.865697 5.25422C0.241382 4.62991 0.241382 3.61001 0.865697 2.9857L2.9857 0.865697ZM3.60314 7.01569C3.61864 6.99464 3.63284 6.97246 3.64562 6.94925C4.41081 5.55884 5.55884 4.41081 6.94925 3.64562C6.97257 3.63278 6.99484 3.61851 7.01598 3.60293C5.57216 4.38221 4.38246 5.57189 3.60314 7.01569ZM14.9838 3.60283C15.005 3.61845 15.0273 3.63276 15.0507 3.64562C16.4411 4.41081 17.5891 5.55884 18.3543 6.94925C18.3672 6.97256 18.3814 6.99482 18.397 7.01595C17.6177 5.57197 16.4278 4.38216 14.9838 3.60283ZM19.6197 6.76878L21.1343 5.25422C21.7586 4.62991 21.7586 3.61001 21.1343 2.9857L19.0143 0.865697C18.3899 0.241382 17.37 0.241382 16.7457 0.865697L15.2312 2.38023C15.6046 2.56389 15.9644 2.7711 16.3086 2.99993L17.5943 1.71423C17.7499 1.55854 18.01 1.55854 18.1657 1.71423L20.2857 3.83423C20.4414 3.98991 20.4414 4.25001 20.2857 4.4057L19 5.69142C19.2288 6.03557 19.436 6.39534 19.6197 6.76878Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group 1479",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M4.79 17.5L2.15 20.15C1.95 20.34 1.95 20.66 2.15 20.85C2.34 21.05 2.66 21.05 2.85 20.85L5.55 18.16C5.28 17.95 5.03 17.74 4.79 17.5Z",
					stroke: "currentColor",
					strokeWidth: 1.2,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M19.8502 20.15L17.2102 17.5C16.9702 17.74 16.7202 17.95 16.4502 18.16L19.1502 20.85C19.2402 20.95 19.3702 21 19.5002 21C19.6302 21 19.7602 20.95 19.8502 20.85C20.0502 20.66 20.0502 20.34 19.8502 20.15Z",
					stroke: "currentColor",
					strokeWidth: 1.2,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Subtract_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11ZM11 4.40002C11.3314 4.40002 11.6 4.66865 11.6 5.00002V10.0779C11.7285 10.1617 11.8384 10.2716 11.9221 10.4H16C16.3314 10.4 16.6 10.6687 16.6 11C16.6 11.3314 16.3314 11.6 16 11.6H11.9221C11.7259 11.901 11.3862 12.1 11 12.1C10.3925 12.1 9.90002 11.6075 9.90002 11C9.90002 10.6139 10.099 10.2742 10.4 10.0779V5.00002C10.4 4.66865 10.6687 4.40002 11 4.40002Z",
				fill: "currentColor"
			})
		]
	})
});
export default SvgAlarmFilled;
